import {Grid, GridItem, Text} from 'platform/foundation';

import {i18n} from '@dms/i18n';

import {PURCHASE_PRICE_BAND_COLUMNS} from '../constants/PURCHASE_PRICE_BAND_COLUMNS';

export function PurchasePriceRuleBandsHeader() {
  return (
    <Grid columns={PURCHASE_PRICE_BAND_COLUMNS.total} spacing={2}>
      <GridItem span={PURCHASE_PRICE_BAND_COLUMNS.bound}>
        <Text size="small" color="secondary" alternative>
          {i18n.t('page.settings.purchasePrice.ruleEditor.bands.recommendedPrice')}
        </Text>
      </GridItem>
      <GridItem span={PURCHASE_PRICE_BAND_COLUMNS.marginType}>
        <Text size="small" color="secondary" alternative>
          {i18n.t('page.settings.purchasePrice.ruleEditor.bands.marginType')}
        </Text>
      </GridItem>
      <GridItem span={PURCHASE_PRICE_BAND_COLUMNS.marginValue}>
        <Text size="small" color="secondary" alternative>
          {i18n.t('page.settings.purchasePrice.ruleEditor.bands.value')}
        </Text>
      </GridItem>
    </Grid>
  );
}
